import { pathOr } from 'ramda'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { MIC_ACCESS_ERROR } from '@/app/definitions'
import { selectToken } from '@/app/module/auth/store/selectors'
import { selectWhatsappSenderIds } from '@/app/module/campaigns/store/selectors'
import { getCustomFields } from '@/app/module/custom-fields/store/actions'
import { getFilesItem } from '@/app/module/files/store/actions'
import { clearFilters, getSenderIdList, saveWhatsappFile, sendWhatsappMessage } from '@/app/module/logs/store/actions'
import { selectPersonalizationList, selectSenderIdValues } from '@/app/module/logs/store/selectors'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId, selectUserId } from '@/app/module/user/store/selectors'

import Conversations from './components'
import {
  getContactData,
  getContactInfo,
  getContacts,
  readAllContactMessages,
  subscribeLogs,
  unsubscribeLogs,
} from './store/actions'

const selector = ({ user, customFields, logs, conversations }) => ({
  token: selectToken(),
  orgId: selectOrgId({ user }),
  userId: selectUserId({ user }),
  personalizationList: selectPersonalizationList({ customFields }),
  smsSenderIds: selectSenderIdValues({ logs }),
  whatsappSenderIds: selectWhatsappSenderIds({ logs }),
  contactInfo: pathOr({}, ['data', 'contactInfo'], conversations),
  loading:
    pathOr([], ['data', 'loadingList'], conversations).length > 0 || pathOr([], ['data', 'loading'], conversations),
  conversations: pathOr([], ['data', 'conversations'], conversations),
  initialized: pathOr([], ['data', 'initialized'], conversations),
  nextPage: pathOr([], ['data', 'nextPage'], conversations),
})

const dispatcher = (dispatch) =>
  bindActionCreators(
    {
      subscribeLogs,
      unsubscribeLogs,
      getContacts,
      getSenderIdList,
      getFilesItem,
      getCustomFields,
      sendWhatsappMessage,
      clearFilters,
      saveWhatsappFile,
      getContactInfo,
      readAllContactMessages,
      getContactData,
      onMicAccessError: () =>
        dispatch(
          createNotification({
            'mic-access': {
              type: 'error',
              message: MIC_ACCESS_ERROR,
            },
          }),
        ),
    },
    dispatch,
  )

export default connect(selector, dispatcher)(withRouter(Conversations))
